import {
  Atom,
  Flame,
  MoveHorizontal,
  StretchHorizontal,
} from 'lucide-react';

const materialPropertyGuides = [
  {
    slug: 'tensile-strength',
    title: 'Tensile Strength',
    Icon: StretchHorizontal,
    summary:
      'Tensile strength tells us how strong the material is.',
    machiningSummary:
      'It is one of the basic clues for choosing how hard the cutting tool should be and whether the cutting edge should be sharp or strong.',
  },
  {
    slug: 'thermal-conductivity',
    title: 'Thermal Conductivity',
    Icon: Flame,
    summary:
      'Thermal conductivity tells us where the heat generated during machining prefers to go — into the chip and workpiece, or into the cutting tool.',
    machiningSummary:
      'This can significantly affect the cutting speed we can use.',
  },
  {
    slug: 'elongation',
    title: 'Elongation',
    Icon: MoveHorizontal,
    summary:
      'Elongation adds another piece of information to tensile strength.',
    machiningSummary:
      'It can change our choice of cutting tool and helps us better understand how the material will behave during machining and chip formation.',
  },
  {
    slug: 'chemical-composition',
    title: 'Chemical Composition',
    Icon: Atom,
    summary:
      'Chemical composition helps reveal other possible machining risks, such as a tendency to work harden during machining or excessive abrasive wear.',
    machiningSummary:
      'It gives us another view of the material and helps us understand how to approach it.',
  },
];

export const getMaterialPropertyGuide = (slug) =>
  materialPropertyGuides.find((guide) => guide.slug === slug);

export default materialPropertyGuides;
